export default __webpack_public_path__ + "static/media/transportation.fe8103ae.svg";